/* Generated by tools/build-localization.mjs. Do not edit by hand. */
const en = {
  "about.body": "We are a group of friends who began researching the ancient and giant trees of Cyprus, then travelling around the island to find and photograph them. This catalogue brings that work together.",
  "about.corrections": "Spotted an error or know a tree missing from our catalogue? Write to us with its name and location, your correction or suggestion and, if possible, photographs or a source.",
  "about.licensing": "Our photographs are credited to the Cyprus Trees team. External photographs link to the page where they were found, and every tree record keeps its research sources.",
  "about.title": "About the project",
  "catalogue.empty": "No trees match these filters. Clear the filters to see the full catalogue.",
  "catalogue.error": "The catalogue could not be loaded. Check your connection and reload the page.",
  "catalogue.filter.age": "Age",
  "catalogue.filter.ageAny": "Any age",
  "catalogue.filter.ageBand": "{{from}}–{{to}} years",
  "catalogue.filter.ageOldest": "1000 years and older",
  "catalogue.filter.ageUnrecorded": "No age on record",
  "catalogue.filter.apply": "Show: {{count}}",
  "catalogue.filter.clear": "Clear filters",
  "catalogue.filter.close": "Close filters",
  "catalogue.filter.done": "Done",
  "catalogue.filter.filters": "Filters",
  "catalogue.filter.maxAge": "To, years",
  "catalogue.filter.minAge": "From, years",
  "catalogue.filter.noSpecies": "No species found",
  "catalogue.filter.onlyUnknownAge": "Only trees with unknown age",
  "catalogue.filter.remove": "Remove: {{label}}",
  "catalogue.filter.search": "Search by name, species or village",
  "catalogue.filter.searchSpecies": "Search species",
  "catalogue.filter.selected": "Selected: {{count}}",
  "catalogue.filter.shortSearch": "Find a tree",
  "catalogue.filter.species": "Species",
  "catalogue.filter.speciesAny": "All species",
  "catalogue.results": "Trees: {{count}}",
  "catalogue.title": "Trees",
  "copy.action": "Copy: {{label}}",
  "copy.failure": "Could not copy. Select and copy the text.",
  "copy.success": "Copied: {{label}}",
  "count.catalogue": "Trees in the catalogue",
  "district.famagusta": "Famagusta",
  "district.kyrenia": "Kyrenia",
  "district.larnaca": "Larnaca",
  "district.limassol": "Limassol",
  "district.nicosia": "Nicosia",
  "district.paphos": "Paphos",
  "footer.navigation": "Footer navigation",
  "footer.note": "A catalogue made by a group of friends travelling around Cyprus.",
  "gallery.close": "Close gallery",
  "gallery.next": "Next",
  "gallery.openPhoto": "Open photograph {{index}} of {{total}}",
  "gallery.position": "{{index}} of {{total}}",
  "gallery.previous": "Previous",
  "gallery.title": "Tree photographs",
  "gallery.viewAll": "View all {{count}}",
  "hero.body": "A growing catalogue and map of remarkable old trees across Cyprus, assembled from published sources and our journeys around the island.",
  "hero.title": "Ancient Trees of Cyprus",
  "language.switch": "Language",
  "location.hint": "Our team has not confirmed that this tree stands at this exact location.",
  "location.uncertain": "Location?",
  "location.unknown": "Location unknown",
  "map.attribution": "© OpenStreetMap contributors",
  "map.listTitle": "Trees on the map",
  "map.title": "Tree map",
  "meta.catalogueDescription": "Browse {{count}} ancient, giant and remarkable trees across Cyprus by species and age, with photographs, locations and source-backed descriptions.",
  "meta.homeDescription": "Explore ancient, giant and remarkable trees across Cyprus in a multilingual field catalogue with photographs, research sources and an interactive map.",
  "meta.imageAlt": "Cyprus Monumental Trees emblem — a hand-drawn olive tree with the outline of Cyprus",
  "meta.mapDescription": "Find ancient, giant and remarkable trees across Cyprus on an interactive map, with photographs and clearly marked unverified locations.",
  "meta.treeDescription": "Explore {{name}} near {{place}}, with photographs, location details and research sources from the Ancient Trees of Cyprus catalogue.",
  "nav.catalogue": "Trees",
  "nav.map": "Map",
  "nav.primary": "Primary navigation",
  "notFound.page": "This page could not be found. Return to the tree catalogue.",
  "photo.creditTeam": "© Cyprus Trees team",
  "photo.creditVia": "Photo source: {{host}}",
  "photo.pending": "We do not yet have a photograph for this tree.",
  "photo.unavailable": "Photograph unavailable",
  "plaque.age": "Age",
  "plaque.coordinates": "Coordinates",
  "plaque.district": "District",
  "plaque.girth": "Girth",
  "plaque.height": "Height",
  "plaque.meters": "m",
  "plaque.protection": "Protection",
  "plaque.protectionMonument": "Nature monument",
  "plaque.species": "Species",
  "plaque.title": "Data",
  "plaque.unknown": "Unknown",
  "plaque.village": "Village",
  "rule.label": "Age of every documented tree",
  "rule.none": "Age unknown",
  "sheet.access": "Access",
  "sheet.funFacts": "Details",
  "sheet.mapsLink": "Open in Google Maps",
  "sheet.notFound": "This tree is not in the catalogue. It may have been removed, merged with another record or linked incorrectly.",
  "sheet.sources": "Sources",
  "sheet.sourcesOwnFieldwork": "This record comes from our field photographs and their coordinates; no separate published source is listed.",
  "sheet.whereItStands": "Location",
  "site.title": "Ancient Trees of Cyprus",
  "species.calabrianPine": "Calabrian pine",
  "species.carob": "Carob",
  "species.cypress": "Cypress",
  "species.ficus": "Ficus",
  "species.goldenOak": "Golden oak",
  "species.grapevine": "Grapevine",
  "species.juniper": "Juniper",
  "species.kermesOak": "Kermes oak",
  "species.laurel": "Laurel",
  "species.multiple": "Several species",
  "species.oak": "Oak",
  "species.olive": "Olive",
  "species.other": "Other species",
  "species.pine": "Black pine",
  "species.pineUnspecified": "Pine",
  "species.plane": "Oriental plane",
  "species.planeUnspecified": "Plane tree",
  "species.stonePine": "Stone pine",
  "species.strawberryTree": "Strawberry tree",
  "species.sycomoreFig": "Sycomore fig",
  "species.terebinth": "Terebinth",
  "species.tipuana": "Tipuana",
  "theme.dark": "Dark",
  "theme.light": "Light",
  "theme.toDark": "Switch to dark theme",
  "theme.toLight": "Switch to light theme",
  "tree.ageLabel": "Age: {{label}} years",
  "tree.ageYears": "{{count}} years old",
  "tree.backToLedger": "Back to all trees",
  "tree.name": "Name",
  "tree.speciesUnrecorded": "Species unrecorded",
  "visit.hint": "Our team has not visited this tree or taken photographs here yet.",
  "visit.notVisited": "Not visited",
} as const;

export default en;
